/**
 * The Edit / Delete / Disable trio that every list table uses.
 * `onDelete` is expected to confirm before it fires.
 */
export default function RowActions({ status, onEdit, onDelete, onToggle, busy }) {
  const disabled = status === 'disabled';
  return (
    <div className="action-btns">
      <button type="button" className="action-btn edit" onClick={onEdit} disabled={busy}>
        Edit
      </button>
      <button type="button" className="action-btn delete" onClick={onDelete} disabled={busy}>
        Delete
      </button>
      <button
        type="button"
        className={`action-btn ${disabled ? 'enable' : 'disable'}`}
        onClick={onToggle}
        disabled={busy}
      >
        {disabled ? 'Enable' : 'Disable'}
      </button>
    </div>
  );
}
